import * as type from './type';

const initialState = {
  activePrecinctId: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case type.SET_ACTIVE_PRECINCT_ID:
      return {
        ...state,
        activePrecinctId: action.data,
      };
    default:
      return state;
  }
};
